let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("63E9Q")).then(() => parcelRequire('asGYW'));